import { countryConfig } from '../countryConfig'

export const getStaticAssetPath = (url: string) => {
  if (process.env.STORYBOOK) {
    const prefix = process.env.STORYBOOK_GH_PAGES_ASSETS_PREFIX ?? ''
    return `${prefix}${url}`
  }
  return countryConfig.basePath + url
}
